var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-building-o","titulo":"FORNECEDORES"},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Fornecedores' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }